// extracted by mini-css-extract-plugin
export default {"info":"Filters_info__BJXGk","group":"Filters_group__O2vWd","checkbox":"Filters_checkbox__eptWx","btns":"Filters_btns__lK5ug","button":"Filters_button__9xE1X"};